import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_tenant_agency: { message: "idle" },
};

export const add_tenant_agency_Slice = createSlice({
 name: "add_tenant_agency",
 initialState,
 reducers: {
  success_add_tenant_agency: (state, action) => {
   state.add_tenant_agency = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_tenant_agency: (state, action) => {
   state.add_tenant_agency = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_tenant_agency: (state) => {
   state.add_tenant_agency = { status: app_consts.IDLE };
  },
  loading_add_tenant_agency: (state) => {
   state.add_tenant_agency = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_tenant_agency, fail_add_tenant_agency, reset_add_tenant_agency, loading_add_tenant_agency } = add_tenant_agency_Slice.actions;

export default add_tenant_agency_Slice.reducer;